/* eslint-disable */

import Vue from 'vue/dist/vue.min.js';
import VueResource from 'vue-resource';
import Spinner from 'vue-simple-spinner';
import dayjs from 'dayjs';
import 'dayjs/locale/nb';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';


const weekNumber = (date) => {

    const MINUTE = 60000;
    const DAY = 86400000;
    const WEEK = 604800000; // = 7 * 24 * 60 * 60 * 1000 = 7 days in ms
    const tzDiff = (first, second) => (first.getTimezoneOffset() - second.getTimezoneOffset()) * MINUTE;


    const day = (date.getDay() + 6) % 7;
    // get thursday of present week
    const thursday = new Date(date);
    thursday.setDate(date.getDate() - day + 3);
    // set 1st january first
    const firstThursday = new Date(thursday.getFullYear(), 0, 1);
    // if Jan 1st is not a thursday...
    if (firstThursday.getDay() !== 4) {
      firstThursday.setMonth(0, 1 + (11 /* 4 + 7 */ - firstThursday.getDay()) % 7);
    }
    const weekNumber = 1 + Math.floor((thursday - firstThursday + tzDiff(firstThursday, thursday)) / WEEK);
    return weekNumber
}

const fallbackCoords = {
    lat: 59.9221739,
    lng: 10.842542099999946
}

const config = {
    workshopEndpoint: "/wp-json/restApi/v1/getWorkshops",
    regnumberEndpoint: "/wp-json/restApi/v1/norbits",
    timeslotsEndpoint: "/wp-json/restApi/v1/getWeek",
    adminAjaxEndpoint: "/wp/wp-admin/admin-ajax.php",
    isStillAvailableEndpoint: "/wp-json/restApi/v1/isDateTimeBooked",
    geolocateEndpoint: "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAHB1A_24V5dKSlHMGZfKx3fgPmXCfJzA0",
    maxAllowedWeek: 32
}

Vue.use(VueResource);

const app = new Vue({
    components: {
        Spinner
    },
    el: '#orderForm',
    data: {
        loading: true,
        postId: null,
        promo: null,
        loadingTimeslots: false,
        errorMsg: null,
        summary: [],
        carError: false,
        date: null,
        time: null,
        information: null,
        userCords: null,
        userLocation: null,
        regNumber: null,
        selectedCar: null,
        dateAndTime: null,
        selectedServices: [],
        serviceClicked: false,
        selectedDateAndTime: null,
        sortedWorkshops: null,
        submitting: false,
        workshop: null,
        success: false,
        gettingTimeslots: true,
        days: null,
        geolocate: true,
        personalia: {
            name: '',
            email: '',
            email2: '',
            phone: '',
        },
        selectedWorkshop: {},
        week: null,
        trueWeek: null,
        year: null,
        canAddWeek: config.maxAllowedWeek,
        workshops: [],
    },
    created: function() {
        this.loading = false;
        this.init();
        this.getWorkshops();
        this.getPersonalia();
        const orderFormChangeButtons = document.querySelectorAll('.order-form-change');
    },
    computed: {
        isReady() {
            if (this.workshop !== undefined || this.workshop !== null) {
                return true;
            }
            return false;
        },
        canAddWeekCheck() {
            if (this.canAddWeek === 0 || this.gettingTimeslots === true) {
              return true;
            }
            return false;
          },
          canRemoveWeekCheck() {
            if (this.canAddWeek === config.maxAllowedWeek || this.gettingTimeslots === true) {
              return true;
            }
            return false;
          },
        prettyFullDate() {
                let newDate = this.selectedDateAndTime.date.split('-');
                let us_date = newDate.reverse().join('-');
                us_date = `${us_date} ${this.selectedDateAndTime.time}`;
                const d = dayjs(us_date);
                return dayjs(us_date).locale('nb').format('dddd DD. MMMM') + ' kl. ' + dayjs(us_date).locale('nb').format('HH:mm');
        },
        prettyDateAndTime() {
            if (this.selectedDateAndTime !== null || this.selectedDateAndTime !== undefined) {
                let newDate = this.selectedDateAndTime.date.split('-');
                let us_date = newDate.reverse().join('-');
                const d = dayjs(us_date);
                return dayjs(us_date).locale('nb').format('DD. MMMM');
            }
            return;
        },
        carYear() {
            var d = new Date(this.selectedCar.registered);
            return d.getFullYear();
        },
        hasServicesAndWorkshop() {
            if (this.workshop !== undefined || this.workshop !== null) {
                return true;
            }
            return;
        },
        googleUrl() {
            // workshop.workshopData.location.lng
            return 'https://www.google.com/maps/place/' + this.workshop.workshopData.lat + ',' + this.workshop.workshopData.long;
        },
        getDate(index) {
            if (this.dateAndTime !== null) {
                return this.dateAndTime;
            }
            return;
        },
        canILookupCar: function() {
            var re = /^([a-zA-z]{2}\d{5})$/;
            return re.test(String(this.regNumber));
        },
        isValid: function() {
            if (this.selectedDateAndTime && this.personalia !== undefined && this.selectedServices.length && this.personalia.phone && this.selectedCar && this.validateEmail(this.personalia.email) && this.personalia.email == this.personalia.email2) {
                return true;
            }
            return false;
        }
    },
    watch: {
        workshop: function() {

            let skipDays = [5,6,0]; // friday, saturday, sunday
            if (this.workshop.workshopData !== undefined) {
                if (this.workshop.workshopData.openSaturday === true) {
                    skipDays = [6,0]; // saturday + sunday
                }
            }
            let today = new Date();

            if (skipDays.includes(today.getDay())) {
                this.week = weekNumber(today) +1;
                this.trueWeek = weekNumber(today) +1;
            } else {
                this.week = weekNumber(today);
                this.trueWeek = weekNumber(today);
            }

            this.selectedServices = [];
            this.selectedDateAndTime = null;
            this.getTimeSlots();
            this.clearServices()
        }
    },
    methods: {
        init() {
            this.postId = document.querySelector('form.order-form').getAttribute('data-post-id');
        },

        stringToSlug(str) {
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
            var to   = "aaaaeeeeiiiioooouuuunc------";
            for (var i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
        },

        clearServices() {
            const btns = document.querySelectorAll('.order-form-button.is-active');
            btns.forEach( (btn) => {
                btn.classList.remove('is-active');
            });
        },
        matchingDate(date) {
            const d = date;
            if (this.selectedDateAndTime !== null && this.selectedDateAndTime.hasOwnProperty('date') && this.selectedDateAndTime.date === d) {
                return true;
            }
            return false;
        },
        isWeekendOrFriday() {
            // if weekend, return true.

            let skipDays = [5,6,0]; // friday, saturday, sunday

            if (this.workshop !== null) {
                if (this.workshop.workshopData.openSaturday == true) {
                    skipDays = [6,0];
                }

            }
            const today = new Date();
            let todayDay = today.getDay();

            if(skipDays.includes(todayDay) && this.workshop !== null) {
                this.week == this.trueWeek + 1;
                return true;
            }
            return;
        },
        getEndpointUrl() {
            if (window.siteUrl !== undefined) {
                return window.siteUrl;
            } else {
                return 'https://www.fixdrive.no';
            }
        },
        removeCar() {
            this.selectedCar = null;
            this.regNumber = null;
        },
        removeAllDateLists() {
            // remove all data properties.
            const activeTimeSlotButton = document.querySelectorAll('[data-selected=true]');
            activeTimeSlotButton.forEach (b => b.removeAttribute('data-selected'));
            activeTimeSlotButton.forEach (b => b.classList.remove('is-active'));
            const availableDateList = document.querySelectorAll('.is-showing-dates');
            availableDateList.forEach (a => a.classList.remove('is-showing-dates'));
        },
        showAvailableDates(event, date) {
            this.removeAllDateLists();
            const parent = event.srcElement.parentElement.parentElement;
            parent.classList.add('is-showing-dates');
        },
        formatDate(date) {
            let newDate = date.split('-');
            let us_date = newDate.reverse().join('-');
            const d = dayjs(us_date);
            return dayjs(us_date).locale('nb').format('DD. MMMM');
        },
        onChange(value) {
            this.workshop = value;
            this.selectedWorkshop = value;
            this.getTimeSlots(); //
        },
        getISOweek(y) {
            var d,
            isLeap;
            d = new Date(y, 0, 1);
            isLeap = new Date(y, 1, 29).getMonth() === 1;

            //check for a Jan 1 that's a Thursday or a leap year that has a
            //Wednesday jan 1. Otherwise it's 52
            return d.getDay() === 4 || isLeap && d.getDay() === 3 ? 53 : 52
        },
        addWeek() {
            const today = new Date();
            if (this.week === this.getISOweek(today.getFullYear())) {
                this.week = 1;
                this.year++;
            } else {
                this.week++;
            }
            this.canAddWeek--;
            this.getTimeSlots();
        },
        subtractWeek() {
            const today = new Date();
            if (this.week === 1) {
                this.week = this.getISOweek(today.getFullYear());
                this.year--;
            } else if (this.week === this.trueWeek) {
                this.week = this.trueWeek
            } else {
                this.week--;
            }
            this.canAddWeek++;
            this.getTimeSlots();
        },
        prettyWeek() {
            if (this.week == this.trueWeek && this.isWeekendOrFriday() !== true) {
                return "Denne uken";
            }
            return 'Uke: ' + this.week;
        },

        getTimeSlots() {
            this.loadingTimeslots = true;
            this.gettingTimeslots = true;

            const timeSlotsEndPoint = this.getEndpointUrl() + `${config.timeslotsEndpoint}?week=${this.week}&year=${this.year}&workshopId=${this.workshop.workshopData.id}&workshop=${this.workshop.workshopData.slug}`;
            const timeSlots = fetch(timeSlotsEndPoint);
            const that = this;
            timeSlots.then( (res) => {


                return res.json();
            }).then( (res) => {
                this.loadingTimeslots = false;
                this.gettingTimeslots = false;
                this.days = res.days;
            }).catch((err) => {
                this.loadingTimeslots = false;
                this.gettingTimeslots = false;
            })

        },

        validateEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        getOrderedLocations() {

            const origin = {lat: this.userLocation.lat, lng: this.userLocation.lng};
            let arr = Object.keys(this.workshops).map((k) => this.workshops[k]);

            const dests = arr.map((w) => {
                return { lat: parseFloat(w.lat), lng: parseFloat(w.long) };
            });

            const that = this;
            var service = new google.maps.DistanceMatrixService();


            if (!this.geolocate && Object.keys(service).length === 0) {

                console.log('failed to get user geolocation and google distance matrix failed.')

                const arrWorkshops = Object.keys(that.workshops).map((k) => that.workshops[k]);
                     const locationsWithOutDistance = arrWorkshops.map( ( w, index ) => {
                     const newObj = {
                        workshopData: w,
                    };
                    return newObj;
                });
                that.sortedWorkshops = locationsWithOutDistance;
                //that.getNearestWorkshopOrSavedWorkshop();
                const location = window.location;
                let url = new URL(location);
                var workshop = url.searchParams.get('w');
                const workShop = localStorage.getItem('workshop.slug'); // gets an int
                if (workshop) {
                    const w = workshop.trim().toLowerCase();
                    this.updateWorkshopSelect(w);

                } else if (workShop !== null) {
                    this.updateWorkshopSelect(workShop);

                } else {
                    this.updateWorkshopSelect('oslo');
                }

            } else {

               service.getDistanceMatrix(
                {
                    destinations: dests,
                    origins: [origin],
                    travelMode: 'DRIVING',
                    unitSystem: google.maps.UnitSystem.METRIC,
                    avoidHighways: false,
                    avoidTolls: false,
                }, function(response, status) {
                    //console.log(response); // fails here
                 if (status === 'OK') {
                  const arrWorkshops = Object.keys(that.workshops).map((k) => that.workshops[k]);
                  const locationsWithDistance = arrWorkshops.map( ( w, index ) => {
                    const googleDistance = response.rows[0].elements[index];
                    const newObj = {
                        googleDistance,
                        workshopData: w,
                    };
                    return newObj;
                });
                that.sortedWorkshops = locationsWithDistance;
                that.getNearestWorkshopOrSavedWorkshop();
                }

                });
            }
        },
        toggleSubService(event, service) {
            let that = this;
            if (!this.selectedServices.includes(service.offerTitle)) {
                that.selectedServices.push(service.offerTitle);
            } else {
                const removeIndex = that.selectedServices.indexOf(service.offerTitle);
                that.selectedServices.splice(removeIndex, 1);
            };
        },
        toggleService(event, service) {
            event.srcElement.parentElement.classList.toggle('is-active');
            let that = this;

            if (!this.selectedServices.includes(service.title)) {
                that.selectedServices.push(service.title);
            } else {
                const index = that.selectedServices.indexOf(service.title);
                that.selectedServices.splice(index, 1);
                if (service.hasOffer) {
                    const input = event.srcElement.parentElement.querySelector('input[type=checkbox]');
                    input.checked = false;

                    const removeSubServiceIndex = that.selectedServices.indexOf(service.offerTitle);
                    if (removeSubServiceIndex !== -1) {
                        that.selectedServices.splice(removeSubServiceIndex, 1);
                    };
                }
            }
        },
        findWorkshop() {
            this.getNearestWorkshop();
        },
        sendOrder() {

            if (this.isValid) {

            this.saveWorkshop();
            this.savePersonalia();
            this.saveCar();
            this.success = true;

            let formData = new FormData();

            // make this more pretty, maybe?
            formData.append('action', 'submit_order');
            formData.append('service[]', this.selectedServices);
            formData.append('workshop', this.workshop.workshopData.name);
            formData.append('workshop_id', this.workshop.workshopData.id);
            formData.append('information', this.information);
            formData.append('regno', this.selectedCar.regNumber);
            formData.append('car_information', JSON.stringify(this.selectedCar));
            formData.append('date_active', this.selectedDateAndTime.date);
            formData.append('time_active', this.selectedDateAndTime.time);
            formData.append('first_name', this.personalia.name);
            formData.append('last_name', this.personalia.name);
            formData.append('email', this.personalia.email);
            formData.append('mobile', this.personalia.phone);
            formData.append('promo_active', this.promo);
            formData.append('post_id', this.postId);

            this.submitting = true;

            window.scrollTo(0,0);
            // popstate?
            history.pushState({orderRecieved: true}, "orderRecieved", "/bestill-time/takk");

            const checkIfStillAvailable = `${this.getEndpointUrl()}${config.isStillAvailableEndpoint}?date=${this.selectedDateAndTime.date}&time=${this.selectedDateAndTime.time}&workshop=${this.workshop.workshopData.slug}`;

            const isBooked = fetch(checkIfStillAvailable, {})
              .then(function (response) {
                return response.json();
              })
              .then(function (myJson) {
                return myJson;
              }).catch((err) => {
                return true;
              });

            isBooked.then( () => {
                const url = `${this.getEndpointUrl()}${config.adminAjaxEndpoint}`;
                this.$http.post(url, formData).then(response => {

                    this.success = true;
                    this.submitting = false;

                }, response => {
                    this.formError = true;
                });
            }).catch( (err) => {
                this.errorMsg = "Oops, noen har booket timen før deg. Prøv igjen.";
                this.selectedDateAndTime = null;
                $('#errorMsg').modal('show');
            })


        } else {
                document.getElementById('email2').classList.remove('has-error');
                // trigger error modal.
                $('#validationError').modal('show');
                $('.order-form').addClass('has-errors');
                //
                if (this.personalia.email != this.personalia.email2) {
                    // set email 2 as error.
                    document.getElementById('email2').classList.add('has-error');
                }
            }
        },
        updateWorkshopSelect(slug) {

            if (this.sortedWorkshops !== null) {
                setTimeout ( () => {
                    try {
                        document.querySelector(`option#${slug}`).selected = 'selected';
                        document.querySelector('select#workshopselect').dispatchEvent(new Event('change'));
                    } catch(err) {
                        // failed to get slug, select manually.
                        console.log('failed');
                        document.querySelector(`select#workshopselect option:nth-of-type(2)`).selected = 'selected';
                        document.querySelector('select#workshopselect').dispatchEvent(new Event('change'));
                    }
                }, 1000); // wait until rendered.

                // if slug in url && found query trigger click
                // wait for render
                setTimeout( () => {
                    let url = new URL(location);
                    var serviceParam = url.searchParams.get('tjeneste');

                    // hack to fix naughty slugs.
                    if (serviceParam === "klimaservice-2") {
                        serviceParam = "klimaservice";
                    } else if (serviceParam === "dekk") {
                        serviceParam = "dekkhotell"
                    }

                    const targetButtonData = "button[data-service-slug='"+ serviceParam +"']";
                    const targetButton = document.querySelector(targetButtonData);
                    //console.log(this.serviceClicked);

                    if (serviceParam && targetButton !== null && this.serviceClicked === false) { targetButton.click(); this.serviceClicked = true; }
                }, 1500)

            }
        },
        setDateAndTime(event, date) {
            this.selectedDateAndTime = date;
            this.removeAllDateLists();
            event.srcElement.parentElement.parentElement.parentElement.querySelector('button').setAttribute('data-selected', true)
            event.srcElement.parentElement.parentElement.parentElement.querySelector('button').classList.add('is-active'); // add dataproperty with selected= true ?
            // handle some visual change to button who triggered this.
        },
        setWorkshop(workshop) {
            //workshop = {...workshop, canBookSaturdays: true};
            this.selectedWorkshop = workshop;
            this.selectedDateTime = null;
        },
        getCarInformation(number) {
            const regNumber = this.regNumber;
            const apiEndpoint = 'https://svendseneksos-stage.dev03.allegro.no' + `${config.regnumberEndpoint}?regNumber=${regNumber}`;
            const that = this;
            this.carError = false;

            fetch(apiEndpoint, {
                mode: 'cors',
            })
                .then(function(response) {
                    return response.json();
                })
                .then(function(myJson) {
                    if (myJson.regNumber !== null) {
                        that.selectedCar = myJson;
                        // save car to localstorate
                    } else {
                        that.selectedCar = null;
                        that.carError = true;

                    }
                }).catch( (err) => {
                    that.errorMsg = 'Kunne ikke kontakte APIet.';
                    $('#errorMsg').modal('show');
                    //console.log('err', err);
                });

        },
        toggleForm() {
            const el = document.querySelector('.order-form__summary');
            el.classList.toggle('is-expanded');
            // toggle body scroll lock
            if (el.classList.contains('is-expanded')) {
                disableBodyScroll(el);
            } else {
                enableBodyScroll(el);
            }
        },
        getUrlService() {
            // read
        },
        getNearestWorkshopOrSavedWorkshop() {

            this.loading = false;

            const location = window.location;
            let url = new URL(location);
            var workshop = url.searchParams.get('w');
            const workShop = localStorage.getItem('workshop'); // gets an int

            if (workshop) {
                const w = workshop.trim().toLowerCase();
                this.updateWorkshopSelect(w);
            } else if (workShop !== null) {
                this.getWorkshop();
            } else {
                this.getNearestWorkshop();
            }
        },
        saveWorkshop() {
            let workshop = this.workshop;
            if (this.workshop !== null || this.workshop !== undefined) {
                localStorage.setItem('workshop', JSON.stringify(workshop.workshopData));
            }

        },
        savePersonalia() {
            // save personalia to localStorage
            let personalia = this.personalia;
            if (this.personalia !== null) {
                localStorage.setItem('personalia', JSON.stringify(personalia));
            }

        },
        getWorkshops() {
            const workshopsEndpoint = this.getEndpointUrl() + `${config.workshopEndpoint}`;
            const that = this;
            return fetch(workshopsEndpoint, {
                mode: 'cors',
              })
              .then(function (response) {
                return response.json();
              })
              .then(function (myJson) {
                that.workshops = myJson.workshops;
                that.getUserLocation(); // async?
              }).catch((err) => {
                that.errorMsg = 'Kunne ikke kontakte APIet!';
              });

        },
        getWorkshop() {
            const workshop = localStorage.getItem('workshop');
            const that = this;
            if (workshop !== undefined || workshop !== null && typeof JSON.parse(workshop) === 'object') {
                that.selectedWorkshop = JSON.parse(workshop);
                that.updateWorkshopSelect(this.selectedWorkshop.slug)
            }
        },
        getPersonalia() {
            const personalia = localStorage.getItem('personalia'); // gets an object
            if (personalia !== null && typeof JSON.parse( personalia ) === 'object') {
                this.personalia = JSON.parse(personalia);
            };

            const lastRegisteredCar = localStorage.getItem('car');
            if (lastRegisteredCar !== null && typeof JSON.parse ( lastRegisteredCar ) === 'object') {
                this.selectedCar = JSON.parse(lastRegisteredCar);
            };

        },
        getDistance(lat1,lon1,lat2,lon2) {
                var R = 6371; // km (change this constant to get miles)
                var dLat = (lat2-lat1) * Math.PI / 180;
                var dLon = (lon2-lon1) * Math.PI / 180;
                var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                    Math.cos(lat1 * Math.PI / 180 ) * Math.cos(lat2 * Math.PI / 180 ) *
                    Math.sin(dLon/2) * Math.sin(dLon/2);
                var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
                var d = R * c;
                if (d>1) return Math.round(d)+"km";
                else if (d<=1) return Math.round(d*1000)+"m";
                return d;
        },
        saveCar() {
            // save the car to localStorage
            let car = this.selectedCar;
            if (car !== null) {
                localStorage.setItem('car', JSON.stringify(car));
            }
        },
        getUserLocation() {
            const that = this;
            if (navigator.geolocation ) {

                var options = {
                    enableHighAccuracy: false,
                    timeout: 5000,
                    maximumAge: 0
                  };
                  function success(position) {
                    that.userLocation = { lat: parseFloat(position.coords.latitude), lng: parseFloat(position.coords.longitude) };
                    that.getOrderedLocations();
                    console.log('got location, all is fine.')
                  }
                    function error(error) {
                        console.log('DEBUG: failed to get navigation geolocation, using google service instead.')
                        let location = fetch(config.geolocateEndpoint, {
                            method: 'POST',
                          });

                          location.then(function (response) {

                              if (!response.ok) {
                                throw Error(response.statusText);
                              }

                            return response.json();
                          })
                          .then(function (myJson) {
                            that.userLocation = {
                              lat: myJson.location.lat,
                              lng: myJson.location.lng
                            }
                            that.getOrderedLocations();

                          }).catch((err) => {
                            that.errorMsg = 'Kunne ikke kontakte APIet.';
                            that.userLocation = fallbackCoords;
                            that.geolocate = false;
                            that.getOrderedLocations();
                            console.log('geolocation failed, geolocation via google failed, hardcoded oslo as userlocation');

                          });
                    }


                navigator.geolocation.getCurrentPosition(success, error, options);

            } else {

                console.log('user refused geolocation, using google geolocation... ')
                jQuery.post( "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAHB1A_24V5dKSlHMGZfKx3fgPmXCfJzA0", function(success) {
                    that.userLocation = { lat: success.location.lat, lng: success.location.lng };
                    that.getOrderedLocations();
                }).fail(function(err) {

                });
            }
        },
        getNearestWorkshop() {

            let locations = [];
            this.loading = true;
            const that = this;

            let arr = Object.keys(this.workshops).map((k) => this.workshops[k]);
            arr.map((w) => {
                locations.push(w);
            });

            function deg2Rad(deg) {
                return deg * Math.PI / 180;
            }

            function pythagorasEquirectangular(lat1, lon1, lat2, lon2) {
                lat1 = deg2Rad(lat1);
                lat2 = deg2Rad(lat2);
                lon1 = deg2Rad(lon1);
                lon2 = deg2Rad(lon2);

                const R = 6371;
                let x = (lon2 - lon1) * Math.cos((lat1 + lat2) / 2);
                let y = (lat2 - lat1);
                let d = Math.sqrt(x * x + y * y) * R;

                return d;
            }

            function getNearestCity(latitude, longitude) {

                let mindiff = 99999;
                let closest;

                for (let i = 0; i < locations.length; i++) {
                    var diff = pythagorasEquirectangular(latitude, longitude, locations[i].lat, locations[i].long);

                    if (diff < mindiff) {
                        closest = i;
                        mindiff = diff;
                    } else {
                        // User is too far away ?
                    }
                }


               if (history.pushState && $('body').hasClass('page-template-templatestemplate-order-blade-php')) {
                   history.pushState(null, null, '#' + locations[closest].slug);
                   that.updateWorkshopSelect(locations[closest].slug);
                };

                return locations[closest];

            }

            if (navigator.geolocation) {

                jQuery.post( "https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyAHB1A_24V5dKSlHMGZfKx3fgPmXCfJzA0", function(success) {
                    that.loading = false;
                    that.userCords = { lat: success.location.lat, lng: success.location.lng }
                    that.setWorkshop( getNearestCity(success.location.lat, success.location.lng) );
                    that.selectedWorkshop = getNearestCity(success.location.lat, success.location.lng);
                })
                    .fail(function(err) {
                        that.errorMsg = 'Fant ikke lokasjon';
                    });
            } else {
                getNearestCity(locations[0][0], locations[0][1]);
            }
        },
    },
    mounted: function() {
        const today = new Date()
        this.week = weekNumber(today)
        this.trueWeek = weekNumber(today);
        this.year = today.getFullYear();
    },
});



// WEBPACK FOOTER //
// ./scripts/orderform/index.js